import { useI18n } from '../context/I18nContext';
import { navigate } from '../shared/lib/router';

/**
 * Breadcrumb trail built purely from route config (never hardcoded
 * strings): Home -> active module's breadcrumbKey -> an optional detail
 * crumb when the path has a sub-segment (e.g. /customers/:id).
 */
export default function Breadcrumbs({ activeModule, pathname }) {
  const { t } = useI18n();

  const crumbs = [{ label: t('common', 'breadcrumb.home'), path: '/' }];

  if (activeModule) {
    crumbs.push({
      label: t(activeModule.breadcrumbKey[0], activeModule.breadcrumbKey[1]),
      path: activeModule.path,
    });

    const remainder = pathname.slice(activeModule.path.length).replace(/^\/+/, '');
    if (remainder) {
      const firstSegment = remainder.split('/')[0];
      const isNew = firstSegment === 'new';

      // Modules that route between fixed sections by path segment (e.g.
      // administration's /administration/users) can define a
      // "breadcrumb.<segment>" key for a specific crumb label; modules that
      // route to a single record by id (customers/vehicles) won't have such
      // a key defined, so t() returns the raw key back unchanged and this
      // falls through to the generic breadcrumbDetail/breadcrumbNew keys
      // exactly as before.
      const segmentKey = `breadcrumb.${firstSegment}`;
      const segmentLabel = t(activeModule.breadcrumbKey[0], segmentKey);
      const fallbackKey = isNew ? 'breadcrumbNew' : 'breadcrumbDetail';
      const label = segmentLabel !== segmentKey ? segmentLabel : t(activeModule.breadcrumbKey[0], fallbackKey);

      crumbs.push({ label, path: pathname });
    }
  }

  return (
    <nav className="app-breadcrumbs" aria-label={t('common', 'breadcrumb.home')}>
      <ol className="app-breadcrumbs__list">
        {crumbs.map((crumb, index) => {
          const isLast = index === crumbs.length - 1;
          return (
            <li key={crumb.path} className="app-breadcrumbs__item">
              {isLast ? (
                <span aria-current="page">{crumb.label}</span>
              ) : (
                <a
                  href={crumb.path}
                  onClick={(event) => {
                    event.preventDefault();
                    navigate(crumb.path);
                  }}
                >
                  {crumb.label}
                </a>
              )}
              {!isLast && <span className="app-breadcrumbs__separator">/</span>}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
